import { ICON_COLOR, ICON_HEIGHT_16, IconNG } from '../../../../../Icon'
import Text from '../../../../../Text'
import { useListingProfileContext } from '../../RentalPortalListingProfile.hooks'

import { getIsListingProfilePhotosMissing } from './RentalPortalListingProfilePhotosWidgetTitle.utils'

import * as styles from './RentalPortalListingProfilePhotosWidgetTitle.module.css'

import ErrorIcon from '../../../../../../icons/error.svg'

function RentalPortalListingProfilePhotosWidgetTitle({
  children,
  className,
  ref,
}) {
  const { isInitiated, listingData } = useListingProfileContext()

  return (
    <span
      className={styles.RentalPortalListingProfilePhotosWidgetTitle}
      ref={ref}
    >
      {getIsListingProfilePhotosMissing({
        isInitiated,
        listing: listingData,
      }) ? (
        <IconNG Icon={ErrorIcon} color={ICON_COLOR.Red} size={ICON_HEIGHT_16} />
      ) : null}
      <Text className={className}>{children}</Text>
    </span>
  )
}

export default RentalPortalListingProfilePhotosWidgetTitle
